// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DuMQRkerPoVYDk_Aygii {
  display: flex;
  align-items: center;
  gap: 0;
  margin: 12px 0;
}

.j249EsqFBcjVoHeZ2GHi {
  width: 249px;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  cursor: pointer;
}

.G6FwIWbQEWMmBoG5eyvu {
  font-family: var(--font-stack-full-regular);
  line-height: 1.5;
  font-size: 1rem;
  font-weight: 500;
  color: var(--grey-color-90);
}

.jz7fRgCEF0EPtG8yMh5y {
  font-family: var(--font-stack-full-heavy);
  line-height: 24px;
  font-size: 1rem;
  font-weight: 800;
  color: var(--grey-color-90);
}

.sMbh4NeHVzcfd5OKQkON {
  width: 100%;
  background-color: var(--grey-color-200);
  padding: 12px;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cuEDvSjHOzi3LM0vCHlh {
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.jJq0BvkKL8CiPhsh12Xj {
  flex: 1 1 48%;
  margin-right: 32px;
}

.uDBkt7RUDTjBWYaSvEmg {
  display: flex;
  align-items: center;
  flex: 1 1 48%;
}

.GZSulz27840IM9HX98vB {
  display: flex;
  padding-left: 12px;
}

.Du_sHR4bFoaY3MB5ZSt4 {
  width: 100%;
}

.WqDpXLjTfZT75XvtyQoj {
  flex: 1 1 48%;
}

.mLcOXux8vrrUQ3DQE9O9 {
  font-family: var(--font-stack-full-medium);
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  color: var(--grey-color-90);
}

.kLKxVkF1D3ct_4mbrjQn {
  width: 100%;
  margin: 24px 0 12px;
  font-size: 20px;
  font-weight: 500;
  line-height: 32px;
  font-family: var(--font-stack-full-medium);
  flex: 1 1 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
}

.S_JSxQORXdJ2trCSLBch {
  width: 241px;
}

.L7919SMgv_BMjYBXEhb9 {
  flex: 1 1 auto;
  display: flex;
}

.BOxITVUEQwWHnfRCMfEc {
  flex: 1 1 48%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 30px;
}

._M7djasxXHAIQeN49DrK {
  margin: 16px 0 24px 0;
}

.A7FiWe9A8ia3A8YfBK1g {
  margin: 12px 0;
}

.imPqTUgz5SHkRyuSeiRe {
  height: 1px;
  margin: 18px 0 24px;
  background-color: var(--grey-color-200);
}`, "",{"version":3,"sources":["webpack://./src/components/ImmersiveAgilityFactorChart/ImmersiveAgilityFactorChart.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,MAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AACF;;AACA;EACE,yCAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;AAEF;;AACA;EACE,WAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AAEF;;AACA;EACE,aAAA;EACA,kBAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AAEF;;AACA;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;EACE,cAAA;EACA,aAAA;AAEF;;AACA;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAEF;;AACA;EACE,qBAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,WAAA;EACA,mBAAA;EACA,uCAAA;AAEF","sourcesContent":[".skillsTitleContainer {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  margin: 12px 0;\n}\n\n.scoreLabelContainer {\n  width: 249px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  cursor: pointer;\n}\n\n.scoringLabel {\n  font-family: var(--font-stack-full-regular);\n  line-height: 1.5;\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--grey-color-90);\n}\n.boxlabelTitle {\n  font-family: var(--font-stack-full-heavy);\n  line-height: 24px;\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--grey-color-90);\n}\n\n.factorChartHeaderComponentBox {\n  width: 100%;\n  background-color: var(--grey-color-200);\n  padding: 12px;\n  border-radius: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.averageAndDistributionBox {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.averageScoreBox {\n  flex: 1 1 48%;\n  margin-right: 32px;\n}\n\n.distributionLevelBox {\n  display: flex;\n  align-items: center;\n  flex: 1 1 48%;\n}\n\n.mainTitleContainer {\n  display: flex;\n  padding-left: 12px;\n}\n\n.titleAverageDistributionContainer {\n  width: 100%;\n}\n\n.distributionLevelMainBoxesContainer {\n  flex: 1 1 48%;\n}\n\n.boxMainTitle {\n  font-family: var(--font-stack-full-medium);\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 32px;\n  color: var(--grey-color-90);\n}\n\n.secondTitleMainBox {\n  width: 100%;\n  margin: 24px 0 12px;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 32px;\n  font-family: var(--font-stack-full-medium);\n  flex: 1 1 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 12px;\n}\n\n.emptyFirstBox {\n  width: 241px;\n}\n\n.averageAndDistributionTitleContainer {\n  flex: 1 1 auto;\n  display: flex;\n}\n\n.averageScoreAndTargetContainer {\n  flex: 1 1 48%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-right: 30px;\n}\n\n.boxesSpacing {\n  margin: 16px 0 24px 0;\n}\n\n.spacingForMiddleBoxes {\n  margin: 12px 0;\n}\n\n.dividerLine {\n  height: 1px;\n  margin: 18px 0 24px;\n  background-color: var(--grey-color-200);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skillsTitleContainer": `DuMQRkerPoVYDk_Aygii`,
	"scoreLabelContainer": `j249EsqFBcjVoHeZ2GHi`,
	"scoringLabel": `G6FwIWbQEWMmBoG5eyvu`,
	"boxlabelTitle": `jz7fRgCEF0EPtG8yMh5y`,
	"factorChartHeaderComponentBox": `sMbh4NeHVzcfd5OKQkON`,
	"averageAndDistributionBox": `cuEDvSjHOzi3LM0vCHlh`,
	"averageScoreBox": `jJq0BvkKL8CiPhsh12Xj`,
	"distributionLevelBox": `uDBkt7RUDTjBWYaSvEmg`,
	"mainTitleContainer": `GZSulz27840IM9HX98vB`,
	"titleAverageDistributionContainer": `Du_sHR4bFoaY3MB5ZSt4`,
	"distributionLevelMainBoxesContainer": `WqDpXLjTfZT75XvtyQoj`,
	"boxMainTitle": `mLcOXux8vrrUQ3DQE9O9`,
	"secondTitleMainBox": `kLKxVkF1D3ct_4mbrjQn`,
	"emptyFirstBox": `S_JSxQORXdJ2trCSLBch`,
	"averageAndDistributionTitleContainer": `L7919SMgv_BMjYBXEhb9`,
	"averageScoreAndTargetContainer": `BOxITVUEQwWHnfRCMfEc`,
	"boxesSpacing": `_M7djasxXHAIQeN49DrK`,
	"spacingForMiddleBoxes": `A7FiWe9A8ia3A8YfBK1g`,
	"dividerLine": `imPqTUgz5SHkRyuSeiRe`
};
export default ___CSS_LOADER_EXPORT___;
